import { render, staticRenderFns } from "./lclAddonSearchBar.vue?vue&type=template&id=0bd2f4be&"
import script from "./lclAddonSearchBar.vue?vue&type=script&lang=js&"
export * from "./lclAddonSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./lclAddonSearchBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd2f4be')) {
      api.createRecord('0bd2f4be', component.options)
    } else {
      api.reload('0bd2f4be', component.options)
    }
    module.hot.accept("./lclAddonSearchBar.vue?vue&type=template&id=0bd2f4be&", function () {
      api.rerender('0bd2f4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/query/lclAddonSearchBar.vue"
export default component.exports